/* global YT */

export default class YouTubeEmbedAPI {

  constructor() {
    console.log('YOUTUBE EMBED API');

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = (() => this.youTubeReady());

    this.player = {};
    this.enabled = false;

  }

  youTubeReady() {
    console.log('YOU TUBE READY!');
  }

  createPlayer(videoID) {
    console.log('PLAYING VIDEO', videoID);
    this.player = new YT.Player('YTPlayer', {
      height: '390',
      width: '640',
      videoId: videoID,
      playerVars: { autoplay: 1,
        showinfo: 0,
        enablejsapi: 1,
        autohide : 1,
      },
      events: {
        onStateChange : (e) => {
          switch (e.data) {
            case YT.PlayerState.PLAYING:
              break;
            case YT.PlayerState.PAUSED:
              break;
            case YT.PlayerState.ENDED:
              break;
            default:
              break;
          }
        },
      },
    } );

    this.enabled = true;
  }

  destroyPlayer() {
    if (this.player) {
      this.enabled = false;
      this.player.stopVideo();
      this.player.destroy();
      delete this.player;
    }
  }


}




// WEBPACK FOOTER //
// ./js/modules/YouTubeEmbedAPI.js